import { useOrgPortalPrefix } from "./OrgPortalPrefix";

export const useIsOrgPortal = () => {
    const orgPortalPrefix = useOrgPortalPrefix();
    return orgPortalPrefix.length > 0;
}